import { useMemo, useState } from 'react';
import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

export const SingleSelectField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const options = field.colOptions || [];
  const showSearch = field.constraints?.show_search_widget === true;
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    if (!showSearch || !query.trim()) return options;
    const q = query.trim().toLowerCase();
    return options.filter((o) =>
      (o.display_title || o.title).toLowerCase().includes(q) || o.title.toLowerCase().includes(q),
    );
  }, [options, query, showSearch]);

  return (
    <FieldShell field={field} error={error}>
      {showSearch && (
        <input
          type="text"
          placeholder="Filter options…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="form-input mb-2"
        />
      )}
      <select
        id={field.title}
        className="form-input"
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{`Select ${field.display_title || field.title}`}</option>
        {filtered.map((o) => (
          <option key={o.title} value={o.title}>
            {o.display_title || o.title}
          </option>
        ))}
      </select>
    </FieldShell>
  );
};
